import React from 'react';
import { ThemeProvider } from 'styled-components';

import { SessionProvider } from '@sdk/session/SessionContext';
import theme from '@sdk/theme/light';

import { Routing } from './Routing';
import './App.css';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <SessionProvider>
        <div className="App">
          <Routing />
        </div>
      </SessionProvider>
    </ThemeProvider>
  );
}
